import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

/**
 * DARK BAND C — Final CTA.
 */
export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta"
      className="rl-dark-band py-28 md:py-40"
      aria-label="Talk to a security expert"
    >
      <span className="rl-dark-band__grid" aria-hidden />
      <span
        className="rl-dark-band__blob"
        aria-hidden
        style={{ width: 720, height: 720, top: -220, left: "35%", background: "#5B2A86" }}
      />
      <span
        className="rl-dark-band__blob"
        aria-hidden
        style={{ width: 560, height: 560, bottom: -160, right: -140, background: "#F5B841", animationDelay: "8s" }}
      />

      <div className="rl-dark-band__inner mx-auto max-w-[1180px] px-6 md:px-10">
        <div className="font-editorial-mono text-[10.5px] text-[#F5B841] mb-6">
          TALK TO A SECURITY EXPERT
        </div>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1] }}
          className="font-editorial-display text-[#F5F5F7] leading-[0.96] tracking-[-0.03em] max-w-[1000px]"
          style={{ fontSize: "clamp(48px, 8vw, 120px)", letterSpacing: "0.005em" }}
        >
          Let's build{" "}
          <span className="font-editorial-italic text-[#F5B841]">your resilience</span>,
          together.
        </motion.h2>

        <div className="mt-10 md:mt-14 flex flex-wrap gap-3 md:gap-4">
          <Link
            to="/contact"
            data-testid="final-cta-primary"
            className="group inline-flex items-center gap-2 rounded-full bg-[#F5F5F7] text-[#0A0B10] px-6 py-3.5 text-[13.5px] hover:bg-[#F5B841] transition-colors"
          >
            Talk to a Security Expert
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
          <Link
            to="/contact"
            data-testid="final-cta-secondary"
            className="group inline-flex items-center gap-2 rounded-full border border-white/25 text-[#F5F5F7] px-6 py-3.5 text-[13.5px] hover:border-[#F5B841] hover:text-[#F5B841] transition-colors"
          >
            Book a Consultation
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 font-editorial-mono text-[10.5px] text-white/60">
          {[
            { label: "NOIDA", sub: "HQ" },
            { label: "GURUGRAM", sub: "NCR" },
            { label: "BANGALORE", sub: "SOUTH" },
            { label: "MUMBAI", sub: "WEST" },
          ].map((c) => (
            <div key={c.label}>
              <div className="text-[#F5F5F7] mb-2">{c.label}</div>
              <div>{c.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
